
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Mail } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { toast } from "sonner";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success(`${email} has been added to our newsletter!`);
    setEmail("");
  };

  return (
    <footer className="bg-bunnie-brown/5 mt-16 border-t border-bunnie-brown/10">
      <div className="container-custom py-16">
        <div className="flex flex-col items-center mb-12">
          <Link to="/" className="flex flex-col items-center">
            <img src="/lovable-uploads/090c1e1d-48a8-4721-b762-b8a2eee74f06.webp" alt="Bunnie Essience Logo" className="h-24" loading="lazy" width="168" height="168" />
            <div className="flex flex-col items-center mt-2">
              <span className="font-serif text-bunnie-brown font-medium text-lg tracking-wide">BUNNIE ESSIENCE</span>
              <span className="text-bunnie-brown/80 text-xs">Clean Hair & Skin Care</span>
            </div>
          </Link>
        </div>

        <div className="flex justify-center mb-10">
          <ul className="flex flex-wrap gap-8 justify-center">
            <li><Link to="/" className="text-bunnie-brown hover:text-opacity-70 transition-all">Home</Link></li>
            <li><Link to="/shop" className="text-bunnie-brown hover:text-opacity-70 transition-all">Shop All</Link></li>
            <li><Link to="/about" className="text-bunnie-brown hover:text-opacity-70 transition-all">Our Story</Link></li>
            <li><Link to="/blog" className="text-bunnie-brown hover:text-opacity-70 transition-all">The Journal</Link></li>
            <li><Link to="/ingredients" className="text-bunnie-brown hover:text-opacity-70 transition-all">Ingredients</Link></li>
            <li><Link to="/faq" className="text-bunnie-brown hover:text-opacity-70 transition-all">FAQ</Link></li>
          </ul>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div className="text-center">
              <h3 className="font-serif text-lg font-medium mb-4 text-bunnie-brown">Contact Us</h3>
              <div className="flex items-center justify-center mb-2">
                <Mail className="h-4 w-4 mr-2 text-bunnie-brown/70" />
                <p className="text-sm text-bunnie-brown/80">hello@bunnieessience.com</p>
              </div>
              <p className="text-sm text-bunnie-brown/80">Hours: Monday-Friday 9AM-5PM EST</p>
              <div className="flex space-x-4 mt-6 justify-center">
                <a href="#" className="text-bunnie-brown hover:text-bunnie-peach transition-colors" aria-label="Instagram"><Instagram size={20} /></a>
                <a href="#" className="text-bunnie-brown hover:text-bunnie-peach transition-colors" aria-label="Facebook"><Facebook size={20} /></a>
                <a href="#" className="text-bunnie-brown hover:text-bunnie-peach transition-colors" aria-label="Twitter"><Twitter size={20} /></a>
              </div>
            </div>
            <div className="text-center">
              <h3 className="font-serif text-lg font-medium mb-4 text-bunnie-brown">Join Our Newsletter</h3>
              <p className="text-sm text-bunnie-brown/80 mb-3">Subscribe for updates, tips, and special offers.</p>
              <form onSubmit={handleSubscribe} className="flex flex-col space-y-2 max-w-xs mx-auto">
                <Input type="email" placeholder="Your email address" className="bg-white border-bunnie-brown/20 text-center" value={email} onChange={(e) => setEmail(e.target.value)} required />
                <Button type="submit" className="bg-bunnie-brown text-white hover:bg-opacity-90 w-full">Subscribe</Button>
              </form>
            </div>
          </div>
          <div className="mt-12 pt-6 border-t border-bunnie-brown/10 text-center">
            <p className="text-sm text-bunnie-brown">© {new Date().getFullYear()} Bunnie Essience. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
